import { computed, makeObservable, observable } from "mobx";

import { ABCStore } from "@noli/business";

export interface IMySpaceStore {
  loading: boolean;
}

class MySpaceStore extends ABCStore<IMySpaceStore> implements IMySpaceStore {
  loading = false;

  constructor() {
    super();
    makeObservable(this, {
      loading: observable,
    });
  }

  get info(): IMySpaceStore {
    return this;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }
}

export const mySpaceStore = new MySpaceStore();
